import { createConsumer } from '@rails/actioncable';

// The support conversation's Contact lives on the fixed support account, not the
// logged-in user's own account — so this subscribes with the Contact's pubsub_token
// and omits user_id, matching the RoomChannel branch that resolves via ContactInbox
// (app/channels/room_channel.rb#current_user) rather than via the logged-in User.
class SupportActionCableConnector {
  constructor(pubsubToken, onMessageReceived) {
    this.consumer = createConsumer();
    this.subscription = this.consumer.subscriptions.create(
      { channel: 'RoomChannel', pubsub_token: pubsubToken },
      {
        received: ({ event, data } = {}) => {
          if (event === 'message.created') {
            onMessageReceived(data);
          }
        },
      }
    );
  }

  disconnect() {
    this.consumer.disconnect();
  }
}

export default SupportActionCableConnector;
